import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import MyApiClient from "../api-client/MyApiClient";

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            swal("Oops", "User Disabled", "error",{ button: "Try Again!",});
            break;

        default:
            return '';
    }
}

export function saveTokenInsessionStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    sessionStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function saveUserTypeInsessionStorage(userType) {
    sessionStorage.setItem('userType', userType);
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        // Pulisce il flag del popup quando si effettua il logout automatico
        try { sessionStorage.removeItem('dashboardPopupDismissed'); } catch {}
        dispatch(Logout(navigate));
    }, timer);
}

export async function checkAutoLogin(location, dispatch, navigate, username, password) {

    /* 1. Se arrivano username e password ⇒ prova il login ------------------- */
    if (username && password) {
        let myApiClient = new MyApiClient();
        const loginResp = await myApiClient.loginWithout2Fa(username, password);

        // Se l'API restituisce { error: … } esco come se fosse fallita l’auto‑login
        if (loginResp?.error) {
            console.warn('Auto‑login fallito:', loginResp.error);
            dispatch(Logout(navigate));
            return;
        }
        
        if (loginResp && loginResp.authorization) {
			onConfirmLogin(loginResp);
		} else {
			dispatch(Logout(navigate));
		    return;
		}
    }

    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        // Escludi le pagine pubbliche dal redirect automatico al login
        const publicPaths = ['/thank-you', '/thank-you/', '/convertphone', '/manageinvite', '/page-register'/*, '/page-register-trial'*/, '/page-forgot-password'];
        const isPublicPath = publicPaths.some(path => 
            location.pathname === path || location.pathname.startsWith(path + '/')
        );
        
        if (!isPublicPath) {
            dispatch(Logout(navigate));
        }
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);

    // Al ripristino di sessione (auto-login), non mantenere il popup chiuso across sessione
    try { sessionStorage.removeItem('dashboardPopupDismissed'); } catch {}
}

async function onConfirmLogin(response) {

    let myApiClient = new MyApiClient();

    try {
    
        let my_token = response.authorization;
        let access_token = response.accessToken;
        let userId = response.userId;

        let response_profile = await myApiClient.getProfile(my_token);

        let userType = '';
        let userLogo = '';
        let clubNature = '';
        let userDisplayName = '';
        let userEmail = '';
        if(response_profile && response_profile.superAdmin /* && response_profile.superAdmin.profileStatus!=='INACTIVE' */) {
            userType = 'superadmin';
            userDisplayName = response_profile.superAdmin.name;
            userLogo = response_profile.superAdmin.logo;
            userEmail = response_profile.superAdmin.email;
        } else if(response_profile && response_profile.club) {

            if(response_profile.club.emailVerified && response_profile.club.emailVerified==='N') {
                //setModalTitle("Errore durante l'operazione");
                //setModalText("La tua struttura è al momento inattiva, conferma il tuo indirizzo e-mail attraverso l'e-mail di registrazione ricevuta per procedere.");
                //setModalShowed(true);
                //setResendShowed(true);
                return;
            } else {
                userType = 'struttura';
                userDisplayName = response_profile.club.name;
                userLogo = response_profile.club.logo;
                clubNature = response_profile.club.clubNature;
                userEmail = response_profile.club.email;
            }
            
        } else {
            //setModalTitle("Errore durante l'operazione");
            //setModalText("Il tuo utente non è abilitato ad accedere");
            //setModalShowed(true);
            return;
        }

        //console.log('3.1');

        let response_formatted = {};
        response_formatted.kink = "";
        response_formatted.localId = userId;
        response_formatted.email = userEmail;
        response_formatted.displayName = userDisplayName;
        response_formatted.idToken = my_token;
        response_formatted.accessToken = access_token;
        response_formatted.expiresIn = 10800;
        response_formatted.logo = userLogo;
        response_formatted.clubNature = clubNature;
        response = response_formatted;

        //console.log('2');

        saveTokenInsessionStorage(response);
        saveUserTypeInsessionStorage(userType);

        //console.log('1');
        window.location.href = '/'+userType+'/dashboard';
        return;
    } catch (error) {
        //setLoadingShowed(false);
        //setModalTitle("Errore durante l'operazione");
        //setModalText("Si è verificato un errore durante l'operazione ("+error+")");
        //setModalShowed(true);
    }
}
